import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import ReactCrop from 'react-image-crop'
import { Modal } from 'react-bootstrap'
import Resizer from 'react-image-file-resizer'
import { yupResolver } from '@hookform/resolvers'
import { schemaDiretorias } from '../../validators/formDiretorias'
import api from '../../services/api'
import { toast } from 'react-toastify'
import AdminMenu from '../../components/AdminMenu'
import Loading from '../../components/Loading'
import nameCapitalize from '../../utils/nameCapitalize'
import Icon from '../../components/Icon'

export default function DiretoriasCadastro() {
  const { id } = useParams();
  const history = useHistory();

  const [form, setForm] = React.useState({
    titulo: '',
    categoria: '',
  });
  const [show, setShow] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [disable, setDisable] = React.useState(false);
  const [srcMain, setSrcMain] = React.useState('');
  const [identifiers, setIdentifiers] = React.useState({
    function: 'create',
    buttonText: 'Cadastrar',
    successMessage: 'Diretoria cadastrada com sucesso!',
  });
  const {
    errors,
    handleSubmit: handleSubmitForm,
    register,
    reset,
    setError,
    setValue,
  } = useForm({
    resolver: yupResolver(schemaDiretorias),
    reValidateMode: 'onBlur',
    mode: 'onBlur',
  });

  const [upImg, setUpImg] = React.useState();
  const imgRef = React.useRef(null);
  const previewCanvasRef = React.useRef(null);
  const defaultCrop = { aspect: 1}
  const [crop, setCrop] = React.useState(defaultCrop)
  const [completedCrop, setCompletedCrop] = React.useState(null);

  useEffect(() => {
    reset(form);
  }, [reset, form]);

  useEffect(() => {
    (async () => {
      if (id) {
        setLoading(true)
        setIdentifiers({
          function: 'edit',
          buttonText: 'Editar',
          successMessage: 'Diretoria editada com sucesso!',
        });

        const response = await api.get(`/diretorias/${id}`);
        setSrcMain(response?.data?.img?.url);
        setForm(response?.data);
        setLoading(false)
      }
    })();
  }, [id]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        170,
        170,
        'jpeg',
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        'blob'
      );
    });

  async function handleSubmit(data) {
    if (identifiers.function === 'edit') {
      try {
        const canvas = previewCanvasRef.current;

        if (completedCrop) {
          canvas.toBlob(
            async (blob) => {
              try {
                const formData = new FormData();
                const resizedFile = await resizeFile(blob);

                formData.set(
                  'file',
                  resizedFile,
                  `${data.nome.replace(' ', '_')}.jpg`
                );
                formData.set('nome', data.nome);
                formData.set('cargo', data.cargo);

                if (data?.moreImages && data?.moreImages?.length > 0) {
                  Array.from(data.moreImages).forEach((item) => {
                    formData.append('moreImages', item, item?.name);
                  });
                }

                await api.put(`/diretorias/${id}`, formData);
                toast.success(identifiers.successMessage);
                // setDisable(false)
                // setLoading(false)
                return history.push('/area-admin/diretorias');
              } catch (err) {
                // setDisable(false)
                // setLoading(false)
                return toast.error(
                  err?.response?.data?.erro ||
                    'Ocorreu um erro ao editar as informações.'
                );
              }
            },
            'image/jpeg',
            1
          );

          return;
        }

        const anotherFormData = new FormData();

        anotherFormData.set('nome', data.nome);
        anotherFormData.set('cargo', data.cargo);

        if (data?.moreImages && data?.moreImages.length > 0) {
          Array.from(data.moreImages).forEach((item) => {
            anotherFormData.append('moreImages', item, item?.name);
          });
        }
        setDisable(true);
        setLoading(true);
        await api.put(`diretorias/${id}`, anotherFormData);
        toast.success(identifiers.successMessage);
        return history.push('/area-admin/diretorias');
      } catch (err) {
        return toast.error(
          err?.response?.data?.erro ||
            'Ocorreu um erro ao editar as informações.'
        );
      }
    }

    try {
      const canvas = previewCanvasRef.current;

      if (!completedCrop) {
        setError('imagem', {
          types: {
            required: true,
          },
          message: 'Campo é obrigatório.',
        });
        return;
      }

      canvas.toBlob(
        async (blob) => {
          try {
            const resizedFile = await resizeFile(blob);
            const oneMoreFormData = new FormData();

            oneMoreFormData.set(
              'file',
              resizedFile,
              `${data.nome.replace(' ', '_')}.jpg`
            );
            oneMoreFormData.set('nome', data.nome);
            oneMoreFormData.set('cargo', data.cargo);

            if (data?.moreImages && data?.moreImages?.length > 0) {
              Array.from(data.moreImages).forEach((item) => {
                oneMoreFormData.append('moreImages', item, item?.name);
              });
            }
            setDisable(true);
            setLoading(true);
            await api.post('/diretorias', oneMoreFormData);
            toast.success(identifiers.successMessage);
            return history.push('/area-admin/diretorias');
          } catch (error) {
            return toast.error(
              error?.response?.data?.erro ||
                'Ocorreu um erro ao criar a diretoria.'
            );
          }
        },
        'image/jpeg',
        1
      );
    } catch (err) {
      return toast.error(
        err?.response?.data?.erro || 'Ocorreu um erro ao criar a diretoria.'
      );
    }
  }

  const onLoadImage = (img) => {
    imgRef.current = img;
  };

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setDisabled(true);
      handleShow(true);
      const reader = new FileReader();
      reader.addEventListener('load', () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleClose = () => {
    imgRef.current = null
    setCompletedCrop(null)
    setCrop(defaultCrop)
    setShow(false)
  };

  const handleConclude = () => {
    setCrop(defaultCrop)
    setShow(false)
  };

  const handleShow = () => setShow(true);

  return (
    <>
      {loading && <Loading delayTime={200} />}
      <AdminMenu />
      <main className="wrapper bg-verm">
        <div className="container mt-3 pt-3">
          <form
            onSubmit={handleSubmitForm(handleSubmit)}
            className='card p-4 border-0'
          >
            <div className='d-flex flex-wrap color-black'>
              <div className='form-group col-12 mb-5'>
                <span
                  className={
                    identifiers.function === 'create' ? 'control-label' : ''
                  }
                >
                  Foto do membro
                </span>
                <div>
                  <input
                    ref={register}
                    type='file'
                    className='form-control-file'
                    name='imagem'
                    id='imagem'
                    accept='image/*'
                    hidden={true}
                    onChange={onSelectFile}
                  />
                  <label htmlFor='imagem'>
                    <canvas
                      ref={previewCanvasRef}
                      width={125}
                      height={125}
                      hidden={!imgRef.current}
                      className='img-input'
                    />
                    {!imgRef.current && srcMain && (
                      <>
                        <img
                          className='img-input '
                          src={srcMain}
                          alt=''
                        />
                      </>
                    )}
                    {!imgRef.current && !srcMain && (
                      <>
                        <div className='img-input  d-flex'>
                          <Icon
                            className='mx-auto my-auto'
                            color='#969cb2'
                            icon='image'
                          ></Icon>
                        </div>
                      </>
                    )}
                    <span className='retorno-invalido'>
                      {errors?.imagem?.message}
                    </span>
                  </label>
                </div>
              </div>

              <Modal
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
                dialogClassName='modal-90w'
              >
                <Modal.Header>
                  <Modal.Title className='modal-title'>Cortar a imagem</Modal.Title>
                    <button
                      onClick={handleClose}
                      type="button"
                      className="btn-close close p-1"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <Icon
                        icon={'times-circle'}
                        size="2x"
                        color="#FFF"
                        className="d2"
                      />
                    </button>
                </Modal.Header>
                <Modal.Body className='teste d-flex align-items-center justify-content-center'>
                  <ReactCrop
                    src={upImg}
                    onImageLoaded={onLoadImage}
                    crop={crop}
                    onChange={(c) => {
                      setDisabled(!(c.width >= 125));
                      return setCrop(c);
                    }}
                    onComplete={(c) => setCompletedCrop(c)}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <button
                    disabled={disabled}
                    className='btn btn-verde'
                    type='button'
                    onClick={handleConclude}
                  >
                    Concluído
                  </button>
                </Modal.Footer>
              </Modal>

              <div className='form-group col-12 col-md-6'>
                <label htmlFor='nome' className='control-label'>
                  Nome
                </label>
                <input
                  id='nome'
                  name='nome'
                  type='text'
                  className='form-control'
                  ref={register}
                  onChange={(e) => setValue('nome', nameCapitalize(e.target.value))}
                />
                <span className='retorno-invalido'>
                  {errors?.nome?.message}
                </span>
              </div>
              <div className='form-group col-12 col-md-6'>
                <label htmlFor='cargo' className='control-label'>
                  Cargo
                </label>
                <input
                  id='cargo'
                  name='cargo'
                  type='text'
                  className='form-control'
                  ref={register}
                />
                <span className='retorno-invalido'>
                  {errors?.cargo?.message}
                </span>
              </div>
            </div>

            <div className='d-flex justify-content-between col-12'>
              <button
                type='button'
                className='btn btn-light border'
                onClick={() => history.push('/area-admin/diretorias')}
              >
                Voltar
              </button>
              <button
                type='submit'
                className='btn btn-verde'
                disabled={disable || loading}
              >
                {identifiers.buttonText}
              </button>
            </div>
          </form>
        </div>
      </main>
    </>
  );
}
